import type { ErrorEvent } from '@sentry/angular';

const EMAIL = /[\w.+-]+(?:@|%40)[\w-]+(\.[\w-]+)+/gi;
const PHONE = /\+?\d(?:[\s-]?\d){8,}/g;

export const scrubPersonalData = (text: string): string =>
  text.replace(EMAIL, '[correo]').replace(PHONE, '[teléfono]');

export function scrubEvent(event: ErrorEvent): ErrorEvent {
  if (event.message) event.message = scrubPersonalData(event.message);
  if (event.request?.url) event.request.url = scrubPersonalData(event.request.url);
  event.exception?.values?.forEach(exception => {
    if (exception.value) exception.value = scrubPersonalData(exception.value);
  });
  event.breadcrumbs?.forEach(breadcrumb => {
    if (breadcrumb.message) breadcrumb.message = scrubPersonalData(breadcrumb.message);
    if (typeof breadcrumb.data?.['url'] === 'string') {
      breadcrumb.data['url'] = scrubPersonalData(breadcrumb.data['url']);
    }
  });
  return event;
}
